import axios from 'axios';

export default {
  state: {
    active: null,
    chats: null,
    chatParty: [],
    chatUsers: null,
    chat_search: {
      my: true,
      caption: null,
    },
  },
  mutations: {
    setChatParty(state, party) {
      state.chatParty = party;
    },
    editChat(state, params) {
      state.active[params.key] = params.val;
    },
    addChats(state, chats) {
      console.log(state.chats,'state.chats');
      state.chats && state.chats.length > 0 ? state.chats.concat(chats) : state.chats = chats;
    },
    setChats(state, chats) {
      state.chats = chats;
    },
    removeChat(state, chat) {
      state.chats = state.chats.filter((item) => item.id !== chat);
    },
    setChatUsers(state, users) {
      state.chatUsers = users;
    },
    setActiveChat(state, active) {
      state.active = active;
    },
    setChatSearch(state, search) {
      state.chat_search = search;
    },
  },
  actions: {
    async createChat({dispatch, commit }, params) {
      let result;
      await axios
        .post(`/api/chats/create`, params)
        .then((response) => {
          commit('addChats', [response.data]);
          result = response.data;
        })
        .catch((error) => {
          if (error.response.data !== 'You token is not verified!' || error.response.data !== 'Your refresh is dead!') {
            dispatch('addError', { message: error.response.data });}
        });
      return result;
    },
    async deleteChat({dispatch }, params) {
      let result;
      await axios
        .post(`/api/chats/delete`, params)
        .then((response) => {
          result = response.data;
        })
        .catch((error) => {
          if (error.response.data !== 'You token is not verified!' || error.response.data !== 'Your refresh is dead!') {
            dispatch('addError', { message: error.response.data });
          }
        });
      return result;
    },
    async chatUsers({dispatch, commit }, user) {
      let result;
      await axios
        .post(`/api/users/chat`, user)
        .then((response) => {
          commit('setChatUsers', response.data);
          result = response.data;
        })
        .catch((error) => {
          if (error.response.data !== 'You token is not verified!' || error.response.data !== 'Your refresh is dead!') {
            dispatch('addError', { message: error.response.data });}
          });
      return result;
    },
    async fetchChats({dispatch, commit }, params) {
      let result;
      await axios
        .post(`/api/chats`, params)
        .then((response) => {
          console.log(params,'params');
          console.log(response.data,'data');
          console.log( params.search.page > 1,' params.search.page > 1');
          params.search.page > 1 ? commit('addChats', response.data) : commit('setChats', response.data);
          result = response.data;
        })
        .catch((error) => {
          if (error.response.data !== 'You token is not verified!' || error.response.data !== 'Your refresh is dead!') {
            dispatch('addError', { message: error.response.data });
          }
        });
      return result;
    },
    async setActiveChat({ commit }, chat) {
      commit('setActiveChat', chat);
    },
    async setChatSearch({ commit }, search) {
      commit('setChatSearch', search);
    },
    async addChat({ state }, chat) {
      state.chats = [chat].concat(state.chats);
    },
    async editChat({ commit }, params) {
      commit('editChat', params);
    },
    async setChat({ commit }, chat) {
      commit('setActiveChat', chat);
    },
    async removeChat({ commit }, chat) {
      commit('removeChat', chat);
    },
    setChatParty({ commit }, party) {
      commit('setChatParty', party);
    },
    async joinChat({ dispatch, commit }, chat) {
      let result;
      await axios
        .post(`/api/chats/join`, chat)
        .then((response) => {
          commit;
          result = response.data;
        })
        .catch((error) => {
          if (error.response.data !== 'You token is not verified!' || error.response.data !== 'Your refresh is dead!') {
            dispatch('addError', { message: error.response.data });}
          });
      return result;
    },
    async addToChat({ dispatch, commit }, chat) {
      let result;
      await axios
        .post(`/api/chats/addusertochat`, chat)
        .then((response) => {
          commit;
          result = response.data;
        })
        .catch((error) => {
          if (error.response.data !== 'You token is not verified!' || error.response.data !== 'Your refresh is dead!') {
dispatch('addError', { message: error.response.data });}
        });
      return result;
    },
  },
  getters: {
    getChats: (s) => s.chats,
    getChatSearch: (s) => s.chat_search,
    getChatUsers: (s) => s.chatUsers,
    getActiveChat: (s) => s.active,
    getPartyChat: (s) => s.chatParty,
  },
};
